import { RippleIcon } from '@marine/icons';
import { FC } from 'react';
import styles from './EmptyState.module.scss';
import { EmptyStateProps } from './EmptyState.props';

const EmptyState: FC<EmptyStateProps> = ({ icon, title, description, actionButton }) => (
  <div className={styles.wrapper}>
    <div className={styles.card}>
      {icon && <RippleIcon icon={icon} />}

      {title && <h3 className={styles.title}>{title}</h3>}

      {description && <p className={styles.description}>{description}</p>}

      {actionButton || null}
    </div>
  </div>
);

export default EmptyState;
